import { keyframes } from 'styled-components';

import type { PolyLoaderConfig } from './PolyLoaderConfig';

export const wave = (config: PolyLoaderConfig) => keyframes`
  0%   { transform: scale(1); fill: ${config.fill}; filter: opacity(1)}
  5%  { transform: scale(1.08); fill: ${config.fill}; filter: opacity(0.9) }
  15%  { transform: scale(1.15); fill: ${config.fillActive}; filter: opacity(1)}
  50%  { transform: scale(1.08); fill: ${config.fillActive}; filter: opacity(0.9) }
  85%  { transform: scale(1); fill: ${config.fill}; filter: opacity(1)}
  100% { transform: scale(1); fill: ${config.fill}; filter: opacity(1)}
`;
